import { Routes, Route } from 'react-router-dom';

import { routes } from '../routes';

import Nav from '../shared/blocks/nav/nav';
import useUserProfile from '../../utilities/hooks/useUserProfile';
import './account-overview.scss';

const AccountOverview = () => {
  useUserProfile();

  return (
    <div className="account-dashboard">
      <Nav />
      <section className="page-content">
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              exact
              element={route.main}
            />
          ))}
        </Routes>
      </section>
    </div>
  );
};

export default AccountOverview;
